import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full" }

import { ref, onMounted, computed } from "vue"
  import { filter, includes, toLower, take, map } from "lodash"
  import { useResourcesStore } from "@/store/resources"
  import { search } from "ionicons/icons"
  import { useCompanyStore } from "@/store/company"
  import { IonToolbar, IonHeader, IonButtons, IonBackButton, IonButton, IonSearchbar, loadingController, IonCheckbox, IonFooter, IonNavLink, IonIcon } from "@ionic/vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'IndustryFilter',
  setup(__props) {

  const resourcesStore = useResourcesStore()
  const companyStore = useCompanyStore()
  const keyword = ref("")
  const data = computed(() =>
    take(
      filter(resourcesStore.industries, (obj: any) => includes(toLower(obj.name), toLower(keyword.value))),
      8
    )
  )
  const selectedValue = () => {
    companyStore.filters.industries = filter(resourcesStore.industries, (obj: any) => obj.checked)
  }
  const reInitialize = () => {
    const selected = map(resourcesStore.industries, (obj: any) => ({ ...obj, checked: false }))
    resourcesStore.industries = selected
    companyStore.filters.industries = []
  }
  onMounted(async () => {
    const loading = await loadingController.create({
      spinner: null,
      message: "Retrieving...",
      translucent: true,
      backdropDismiss: false,
    })
    await loading.present()
    await resourcesStore.retrieveIndustries()
    if (companyStore.filters.industries.length) {
      const selectedID = map(companyStore.filters.industries, "id")
      const selected = map(resourcesStore.industries, (obj: any) => {
        if (includes(selectedID, obj.id)) obj.checked = true
        return obj
      })
      resourcesStore.industries = selected
    }
    loading.dismiss()
  })

return (_ctx: any,_cache: any) => {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonBackButton))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { class: "ion-padding" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_ion_list, { class: "w-full rounded-[8px] shadow-base p-3" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonSearchbar), {
                modelValue: keyword.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
                animated: true,
                placeholder: "Search for industries",
                debounce: 1000,
                class: "w-full p-0 custom",
                color: "light"
              }, null, 8, ["modelValue"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (result) => {
                return (_openBlock(), _createBlock(_component_ion_item, {
                  key: `${result}_id`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(result.name), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(IonCheckbox), {
                      slot: "end",
                      modelValue: result.checked,
                      "onUpdate:modelValue": ($event: any) => ((result.checked) = $event),
                      name: "industries",
                      value: result.id,
                      onIonChange: _cache[1] || (_cache[1] = ($event: any) => (selectedValue()))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "value"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(IonFooter), { class: "ion-no-border" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), { class: "p-5" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButton), {
              expand: "block",
              color: "white",
              class: "text-primary-violet font-bold rounded-base shadow-base",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (reInitialize()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Clear")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})